import {APP_INITIALIZER, ApplicationConfig, ErrorHandler, importProvidersFrom} from '@angular/core';
import {ExtraOptions, provideRouter, withRouterConfig} from '@angular/router';

import {routes} from './app.routes';
import {DatePipe, registerLocaleData} from "@angular/common";
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import localeDe from '@angular/common/locales/de';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatPaginatorIntl} from "@angular/material/paginator";
import {TranslatedMatPaginator} from "./services/translation/translate-mat-paginator";
import {OAuthModule, OAuthStorage} from "angular-oauth2-oidc";
import {SecondsToMillisecondsPipe} from "./pipes/seconds-to-millis.pipe";
import {MillisecondsToSecondsPipe} from "./pipes/millis-to-seconds.pipe";
import {TokenInterceptor} from "./services/auth/token.interceptor";
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from "@angular/material/form-field"
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {MARKED_OPTIONS, provideMarkdown} from "ngx-markdown";
import {GlobalErrorHandler} from "./services/error-handling/global-error-handler";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

registerLocaleData(localeDe);

export function appInitializerFactory(translate: TranslateService) {
  return () => {
    // const lang = translate.getBrowserLang() || 'de'; // use when browser language should be used
    const lang = 'de';
    translate.setDefaultLang(lang);
    return translate.use(lang).toPromise();
  };
}

const config: ExtraOptions = {
  useHash: false,
  scrollPositionRestoration: 'enabled',
  paramsInheritanceStrategy: 'always' //INFO: keep eye on and be careful with parameter names in parent and child routes
};


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withRouterConfig(config)),
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      HttpClientModule,
      OAuthModule.forRoot(),
      TranslateModule.forRoot({
        defaultLanguage: 'de',
        loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
        }
      }),
      MatSnackBarModule
    ),
    MillisecondsToSecondsPipe,
    SecondsToMillisecondsPipe,
    DatePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService],
      multi: true
    },
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    // {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {scrollStrategy: new NoopScrollStrategy()}},
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    {provide: OAuthStorage, useValue: localStorage},
    // {provide: LOCALE_ID, useValue: 'de'},
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline', subscriptSizing: 'dynamic'}},
    // {provide: MAT_CHIPS_DEFAULT_OPTIONS, useValue: {separatorKeyCodes: [COMMA, SPACE]}},
    {provide: MatPaginatorIntl, useClass: TranslatedMatPaginator},
    provideMarkdown(
    //   {
    //   markedOptions: {
    //     provide: MARKED_OPTIONS,
    //     useValue: {
    //       gfm: true,
    //       breaks: false,
    //       pedantic: false,
    //     },
    //   },
    // }
    )
  ]
};


